import React from 'react';

import Select from 'react-select';

import { useGetQuery } from 'api/useGetQuery';
import { ENDPOINTS } from 'api/endpoints';
import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
import assetClassesWithFundStructures from 'utils/assetClassesWithFundStructures';
import { ValueObject } from 'types/ValueObject';
import { DataPoint } from 'types/DataPoint';

type Props = {
  name: string;
  // eslint-disable-next-line no-unused-vars
  onApply: (value: any) => void;
  value: number;
  assetClassId: number;
  vehicleTypeId: number;
  // eslint-disable-next-line no-unused-vars
  mapColumnLabels: (columnName: string, dataPoints: DataPoint[]) => void;
};

type LookupResult = {
  id: number | string;
  name: string;
};

const LookupCell: React.FC<Props> = ({
  name,
  onApply,
  value,
  assetClassId,
  vehicleTypeId,
  mapColumnLabels,
}: Props) => {
  const [dataEnvironment] = useDataEnvironment();
  let endpoint = ENDPOINTS[name](dataEnvironment!.id);
  if (name === 'investmentFocusId') {
    endpoint = ENDPOINTS.investmentFocusId(dataEnvironment!.id, assetClassId);
  } else if (name === 'reportingMethodId') {
    endpoint = ENDPOINTS.reportingMethodId(dataEnvironment!.id, vehicleTypeId);
  }
  const { isLoading, data } = useGetQuery<LookupResult[]>(endpoint, { staleTime: Infinity });

  let foundResult: LookupResult | undefined;

  let transform = (results: any[]) => results.map((item) => item);
  if (name === 'currencyCode') {
    transform = (results: any[]) =>
      results.map(({ code, name }) => ({ id: code, name: name } as LookupResult));
  } else if (name === 'performanceFrequency') {
    foundResult = data?.find(({ id }) => id === value);
    transform = (results: any[]) =>
      results.map(({ name }) => ({ id: name, name: name } as LookupResult));
  }

  const showNoOptions = () => {
    return (
      name === 'fundStructureId' &&
      (!assetClassId || !assetClassesWithFundStructures.includes(assetClassId))
    );
  };

  const lookupResults = showNoOptions() ? [] : transform(data || []);

  mapColumnLabels(name, lookupResults);

  let valueResult: LookupResult = { id: 0, name: '' };
  foundResult = foundResult || lookupResults?.find(({ id }) => id === value);
  if (foundResult) {
    valueResult = foundResult;
  }
  const valueObject: ValueObject =
    name === 'performanceFrequency'
      ? { value: valueResult.name, label: valueResult.name }
      : { value: valueResult.id, label: valueResult.name };

  return (
    <div className="form-group" style={{ zIndex: 99999, marginBottom: 0 }}>
      <Select
        options={(lookupResults || []).map(({ id, name }: LookupResult) => ({
          value: id,
          label: name,
        }))}
        onChange={onApply}
        isLoading={isLoading}
        isClearable={false}
        menuPortalTarget={document.body}
        value={valueObject}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        menuPlacement="auto"
      />
    </div>
  );
};

export default LookupCell;
